import { ifAuthenticated } from "@/router";

export default [
  // Global Settings
  {
    path: "/global-settings",
    name: "globalSettingsIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "globalSettings" */ "@/views/global-setting/Index.vue")
  },

  // Global Default Unit Attributes
  {
    path: "/global-unit-attributes",
    name: "globalUnitAttributesIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "globalSettings" */ "@/views/global-setting/DefaultUnitAttributes.vue")
  },

  // Global Incentives
  {
    path: "/global-incentives",
    name: "globalIncentivesIndex",
    beforeEnter: ifAuthenticated,
    component: () =>
      import(/* webpackChunkName: "globalSettings" */ "@/views/global-setting/Incentives.vue")
  }
];
